import PopOptionState from '../store/schema/PopOptionState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { getPopImapConfiguration, savePopImapConfiguration } from 'owa-popimap-configuration';
import { PopImapConfigurationState } from 'owa-popimap-configuration';

export interface SavePopOptionState {
    optionState: PopOptionState;
    popImapConfigurationState: PopImapConfigurationState;
}

let savePopOption = select<SavePopOptionState>({
    optionState: () => store,
    popImapConfigurationState: () => getPopImapConfiguration(),
})(
    action('savePopOption')(async function savePopOption(state?: SavePopOptionState) {
        (state.popImapConfigurationState.popEnabled =
            state.optionState.popEnabled != null
                ? state.optionState.popEnabled
                : state.popImapConfigurationState.popEnabled),
            (state.popImapConfigurationState.popMessageDeleteEnabled =
                state.optionState.popMessageDeleteEnabled != null
                    ? state.optionState.popMessageDeleteEnabled
                    : state.popImapConfigurationState.popMessageDeleteEnabled),
            await savePopImapConfiguration(state.popImapConfigurationState);
    })
);

export default savePopOption;
